import { Button, Col, Input, Row } from 'reactstrap'
import styles from './AddNew.module.scss'
import Multiselect from '../../../../../components/common/MultiselectDropdown/Multiselect'
import ProductSelection from './ProductSelection/ProductSelection'

const AddNewVoucher = () => {

    return (
        <div>
            <div>
                <div className={styles['heading']}>Details</div>
                <div className='p-2 bg-white'>

                    <div className={styles['wrapper']}>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Promotion Period:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Row className='g-0'>
                                    <Col xs='5'>
                                        <Input type='date' />
                                    </Col>
                                    <Col xs='2' className='d-flex justify-content-center align-items-center fw-bold'>-</Col>
                                    <Col xs='5'>
                                        <Input type='date' />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Budget:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown menu" options={['Store Credit', 'Product Specific']} />
                            </Col>
                        </Row>

                    </div>
                </div>

            </div>

            <div>
                <div className={styles['heading']}>Conditions</div>
                <div className='p-2 bg-white'>

                    <div className={styles['wrapper']}>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                            Minimum Purchase Value:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Input type='text' placeholder='Enter name of the product' />
                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                            Maximum Uses:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown" options={['SMS', "Email"]} />

                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                            Apply to:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown" options={['Store page', 'Product detail page']} />
                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                            Target Groups:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown" options={['Store page', 'Product detail page']} />
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>

            <div>
                <div className={styles['heading']}>Conditions</div>
                <div className='p-2 bg-white'>

                    <div className={styles['wrapper']}>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Minimum Purchase Value:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Input placeholder='Enter name of the product' />
                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                                Apply to:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown" options={['General use/Specific products']} />
                            </Col>
                        </Row>
                        <Row className='g-0 align-items-center'>
                            <Col xs='12' lg='2'>
                            Target Groups:
                            </Col>
                            <Col xs='12' lg='4'>
                                <Multiselect title="Choose from dropdown" options={['New customers', 'Frequent buyers', 'Individual customers']} />
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>

            {/*  Product selection  */}
            <ProductSelection />

            <div className='d-flex justify-content-center'>
                <div className={styles.BtnContainer}>

                    <div className={styles['btn']}>
                        Cancel
                    </div>

                    <Button type="button" color="primary" className={styles.Btn} onClick={() => { }}>
                        Submit
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default AddNewVoucher